module.exports = __webpack_public_path__ + "8873b872fddd62ebb781b6d1f07abc3f.svg";